import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AssetBreakdown from './asset-breakdown.jsx';
import CategoryBreakdown from './category-breakdown.jsx';

import Grid, { Column } from '../../Grid/index.jsx';


import { fetch as fetchAssets, isAssetsLoading, getAssetById } from '../../../Store/assets.js';
import { fetch as fetchPortfolio, isPortfolioLoading, getAssetQuantityById } from '../../../Store/portfolio.js';

class PortfolioBreakdown extends React.Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let content = null;

    if (!this.props.loading && this.props.portfolios?.length) {
      content = (
        <React.Fragment>
          <h2>{this.props.title}</h2>
          <Grid>
            <Column>
              <AssetBreakdown portfolio={this.props.portfolios} />
            </Column>
            <Column>
              <CategoryBreakdown portfolio={this.props.portfolios} />
            </Column>
          </Grid>
        </React.Fragment>
      );
    }

    return content;
  }
}

PortfolioBreakdown.propTypes = {
  title: PropTypes.string,
  portfolios: PropTypes.array,
  loading: PropTypes.bool,
  fetch: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  const { portfolios: ownPortfolios } = ownProps;
  const portfolios = {};

  ownPortfolios?.forEach(portfolio => {
    const { assets, id: portfolioId } = portfolio;

    assets?.forEach(assetId => {
      const assetQuantity = getAssetQuantityById(state, assetId, portfolioId);
      const asset = getAssetById(state, assetId);

      if (asset && assetQuantity) {
        if (!portfolios[assetId]) {
          portfolios[assetId] = { asset: asset, value: 0 };
        }
        portfolios[assetId].value += asset.price * assetQuantity;
      }
    });
  });

  return {
    loading: isAssetsLoading(state) || isPortfolioLoading(state),
    title: ownProps?.title || 'Breakdown of all Portfolios',
    portfolios: Object.values(portfolios)
  };
};

const mapDispatchToProps = function(dispatch, ownProps) {
  return {
    fetch: function() {
      dispatch(fetchAssets());
      dispatch(fetchPortfolio());
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(PortfolioBreakdown);

